import React, { Component } from 'react';
import { PhotoSwipeGallery, PhotoSwipe } from 'react-photoswipe';
import './photoswipe.scss';

class PhotoSwipeZoom extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let items = [];
    let altImagesToUse = this.props.passedFunctions.parentState.productImagesArray;

    if (this.props.contentData.altImages) {
      for (let i = 0; i < altImagesToUse.length; i++) {
        let itemObject = {
          src: `https://dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${altImagesToUse[i].imageName}.jpg`,
          w: 880,
          h: 1020,
        };

        items.push(itemObject);

        if (altImagesToUse[i].imageName === this.props.selectedMainImg) {
          this.props.updateZoomIndex(i);
        }
      }
    } else {
      let itemObject = {
        src: this.props.contentData.fullImage.imageName,
        w: 880,
        h: 1020,
      };
      items.push(itemObject);
    }

    return (
      <PhotoSwipe
        isOpen={this.props.isOpen}
        items={items}
        options={this.props.options}
        close={this.props.handleClose}
      />
    );
  }
}

class MainImagePhotoSwipeZoom extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let items = [];
    let altImagesToUse = this.props.passedFunctions.parentState.productImagesArray;

    if (this.props.contentData.altImages) {
      for (let i = 0; i < altImagesToUse.length; i++) {
        let itemObject = {
          src: `https://dimg.dillards.com/is/image/DillardsZoom/main/${this.props.contentData.fullImage.imageNameForUrl}/${altImagesToUse[i].imageName}.jpg`,
          w: 880,
          h: 1020,
        };

        items.push(itemObject);
      }
    } else {
      let itemObject = {
        src: this.props.contentData.fullImage.imageName,
        w: 880,
        h: 1020,
      };
      items.push(itemObject);
    }

    return (
      <PhotoSwipe
        isOpen={this.props.isOpen}
        items={items}
        options={this.props.options}
        close={this.props.handleClose}
      />
    );
  }
}

export { PhotoSwipeZoom, MainImagePhotoSwipeZoom };

export default PhotoSwipeZoom;
